import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { BaseComponent } from '../../../components/BaseComponent';
import { Button } from '../../../components/Buttons';
import { ViesLabel } from '../../Companies/components/ViesLabel';
import { Modal, ModalControls } from '../../../components/Modal';

const STATE = {};

/* eslint-disable react/prefer-stateless-function */
class ViesCheckPromptComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {}

  reset() {
    this.setState({ ...STATE });
  }

  get invoice() {
    return this.props.invoice;
  }

  get modalMsg() {
    return <p>{this.lbl(`vies.vies_check.incorrect.msg`)}</p>;
  }

  onConfirm() {
    this.props.onConfirm();
  }

  onCancel() {
    this.props.onCancel();
  }

  render() {
    return (
      <Modal onClose={this.onCancel.bind(this)} title={this.lbl(`invoice.details.warning`)}>
        <ViesLabel vies={false} />
        {this.modalMsg}
        <ModalControls>
          <Button onClick={this.onConfirm.bind(this)} primary>
            {this.lbl('confirm')}
          </Button>
          <Button onClick={this.onCancel.bind(this)}>{this.lbl('cancel')}</Button>
        </ModalControls>
      </Modal>
    );
  }
}

ViesCheckPromptComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const ViesCheckPrompt = compose(
  withConnect,
  withRouter,
)(ViesCheckPromptComp);
